export const setSwitcher = switcher => ({
    type: 'SET_SWITCHER',
    payload: switcher,
  });